// let endpoint = 'http://127.0.0.1:8001/api'

// let endpoint = 'https://api.keldenuniversity.org/api'
// let endpoint = 'https://api.dev.keldenuniversity.org/api'

const endpoint = process.env.VUE_APP_API_ENDPOINT;

export default endpoint

